export default "__VITE_ASSET__BFa5HUrN__"